module.exports = __WEBPACK_EXTERNAL_MODULE_80__;


//////////////////
// WEBPACK FOOTER
// external "loadjs"
// module id = 80
// module chunks = 3